import React from 'react'

interface BoldTextPartsProps {
  text: string
  className?: string
  highlightChar?: string
}

export function BoldTextParts({
  text,
  className,
  highlightChar = '*',
}: BoldTextPartsProps) {
  const regex = new RegExp(`\\${highlightChar}(.*?)\\${highlightChar}`, 'g') // get expressions between highlightChar
  const formattedText = text.replace(regex, '<strong>$1</strong>')

  return (
    <p
      className={className}
      dangerouslySetInnerHTML={{ __html: formattedText }}
    />
  )
}
